import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Col} from 'reactstrap';
import propTypes from 'prop-types';

export default class Header extends Component{
    render(){
        
        return(
            <Col xs={12} md={12} className="section">
                <div className="header text-center">
                    Thank you!<br/>
                    We have received your order. <br />
                    <span className="invoice-number">ORD ID {this.props.invoice_number}</span><br/>
                    {/* Please Pay. */}
                </div>
            </Col>
        )
    }
}
Header.propTypes={
    invoice_number:propTypes.string.isRequired
}